export const getters = {
  categoriesShown: (state) => {
    let categoriesShown = []
    for (const category of state.categories) {
      if (
        category.showOnInspection &&
        category.serviceCategoryType !== 'PRE' &&
        category.serviceCategoryType !== 'CC'
      ) {
        categoriesShown.push(category)
      }
      if (category.serviceCategoryType === 'CC') {
        categoriesShown.push(category)
      }
    }

    return categoriesShown
  },
  totalEstimateCount (state, getters) {
    const categoriesTallied = getters.categoriesShown.filter(category => {
      return ['1', '2', '5', '6', '7', '8', '9'].includes(category.id)
    })
    let total = 0
    for (const category of categoriesTallied) {
      total += getters.categoryServicesShownOnRoute(category.id).length
    }
    return total
  },
  categoryName: (state) => (id) => {
    const idMap = {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '5',
      7: '5',
      8: '5',
      9: '5'
    }
    const category = state.categories.find((category) => category.id === idMap[id])
    return category ? category.name : ''
  },
  isPass: (state) => (id) => {
    const idMap = {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '5',
      7: '5',
      8: '5',
      9: '5'
    }
    const category = state.categories.find((category) => category.id === idMap[id])
    if (
      category &&
      typeof category.serviceCategoryType === 'string' &&
      category.serviceCategoryType.toLowerCase() === 'pass'
    ) {
      return true
    } else return false
  },
  categoryById: (state) => (id) => {
    return state.categories.find((category) => state.categoryIdMap[id] === category.id)
  },
  categoryServicesShownOnRoute: (state, getters) => (id) => {
    if (state.route.name === 'additional' || state.route.name === 'additional-services') {
      return getters.categoryServices(id).filter(service => service.isHighlighted)
    }
    if (state.route.name === 'wait' || state.route.name === 'wait-services') {
      return getters.categoryServices(id).filter(service => !service.isHighlighted && service.deferred)
    }
    return getters.categoryServices(id)
  },
  categoryServices: (state, getters) => (id) => {
    let nested = []
    let flattened = []
    if (id < '5') {
      nested = state.services.filter((service) => service.category === id)
    } else {
      nested = state.services.filter((service) =>
        service.category === '6' ||
          service.category === '7' ||
          service.category === '8' ||
          service.category === '9'
      )
    }

    for (const service of nested) {
      if (service.subServices) {
        flattened = flattened.concat(service.subServices)
      } else {
        flattened.push(service)
      }
    }

    // Filter out services that are already child sublets of other services
    // to avoid duplicate keys when rendering
    const childSubletIds = new Set()
    flattened.forEach((service) => {
      if (service.subletServices && service.subletServices.length > 0) {
        service.subletServices.forEach((sublet) => {
          childSubletIds.add(sublet.id)
        })
      }
    })
    
    // Also filter out duplicate standalone sublets by base ID
    // (some sublets have both "123" and "123-0" records)
    const seenBaseIds = new Map() // baseId -> service (prefer one without suffix)
    const standaloneSubletDuplicateIds = new Set()
    
    flattened.forEach((service) => {
      if (service.isStandAloneSublet === true) {
        // Extract numeric base ID
        const numericMatch = service.id.match(/^(\d+)/)
        if (numericMatch) {
          const baseId = numericMatch[1]
          const hasSuffix = service.id.includes('-')
          
          if (seenBaseIds.has(baseId)) {
            const existing = seenBaseIds.get(baseId)
            const existingHasSuffix = existing.id.includes('-')
            
            // Prefer the record without suffix
            if (hasSuffix && !existingHasSuffix) {
              standaloneSubletDuplicateIds.add(service.id)
            } else if (!hasSuffix && existingHasSuffix) {
              standaloneSubletDuplicateIds.add(existing.id)
              seenBaseIds.set(baseId, service)
            } else {
              // Both have or don't have suffix - mark current as duplicate
              standaloneSubletDuplicateIds.add(service.id)
            }
          } else {
            seenBaseIds.set(baseId, service)
          }
        }
      }
    })
    
    return flattened.filter((service) => 
      (service.parentServiceLineIdForSublet === null || service.parentServiceLineIdForSublet === undefined) &&
      !childSubletIds.has(service.id) && 
      !standaloneSubletDuplicateIds.has(service.id)
    )
  },
  categoryContainsHiglightedServices: (state, getters) => (id) => {
    return getters.categoryServices(id).some((service) => service.isHighlighted)
  },
  categoryContainsUnhiglightedServices: (state, getters) => (id) => {
    return getters.categoryServices(id).some((service) => !service.isHighlighted)
  },
  count: (state, getters) => {
    let fail = 0
    let warning = 0
    let approved = 0
    let pass = 0
    let actionableConcern = 0
    let greenConcern = 0

    state.services.forEach((service) => {
      if (service.category === '1') {
        if (service.subServices) {
          fail = fail + service.subServices.length
        }
      } else if (service.category === '2') {
        if (service.subServices) {
          warning = warning + service.subServices.length
        }
      } else if (service.category === '3') {
        if (service.subServices) {
          pass = pass + service.subServices.length
        } else {
          pass++
        }
      } else if (service.category === '4') {
        if (service.subServices) {
          approved = approved + service.subServices.length
        } else {
          approved++
        }
      } else if (
        service.category === '6' ||
        service.category === '7'
      ) {
        if (service.subServices) {
          actionableConcern = actionableConcern + service.subServices.length
        } else {
          actionableConcern++
        }
      } else if (
        service.category === '8' ||
        service.category === '9'
      ) {
        if (service.subServices) {
          greenConcern = greenConcern + service.subServices.length
        } else {
          greenConcern++
        }
      }
    })
    return {
      fail,
      warning,
      approved,
      pass,
      concern: actionableConcern + greenConcern,
      actionable: fail + warning + actionableConcern
    }
  },
  additionalServices: (state, getters) => {
    let highlighted = []
    for (const category of state.categories) {
      if (!getters.isPass(category.id) && category.id !== '4') {
        const services = getters.categoryServices(category.id).filter(service => service.isHighlighted)
        highlighted = highlighted.concat(services)
      }
    }
    return highlighted
  },
  actionableAdditionalServices: (state, getters) => {
    return getters.additionalServices.filter(service => {
      let include = true
      if (service.category === '1' || service.category === '2') {
        if (!service.parentServiceId && !service.subServices) {
          include = false
        }
      }
      if (service.category >= '8') {
        include = false
      }
      return include
    })
  },
  deferredServices: (state, getters) => {
    let deferred = []
    for (const service of state.services) {
      if (service.category !== '3' && service.category !== '4' && service.category < '8') {
        if (service.subServices) {
          for (const subService of service.subServices) {
            if (subService.deferred && !subService.isHighlighted) {
              deferred.push(subService)
            }
          }
        } else if (service.deferred && !service.isHighlighted) {
          deferred.push(service)
        }
      }
    }
    deferred.sort((a, b) => {
      const aSortOrder = getters.categoryById(a.category).sortOrder
      const bSortOrder = getters.categoryById(b.category).sortOrder
      return aSortOrder - bSortOrder
    })
    return deferred
  },
  actionableDeferredServices: (state, getters) => {
    return getters.deferredServices.filter(service => {
      if (service.category === '1' || service.category === '2') {
        if (!service.parentServiceId && !service.subServices) {
          return false
        }
      }
      return true
    })
  },
  previouslyApprovedServices: (state, getters) => {
    const additional = getters.additionalServices.length > 0
    const services = []
    const seenIds = new Set() // Track seen IDs to avoid duplicates
    if (additional) {
      for (const service of state.services) {
        if (service.subServices) {
          for (const subService of service.subServices) {
            if (
              !subService.deferred &&
              !subService.isHighlighted &&
              subService.category !== '3' &&
              subService.category !== '4' &&
              subService.declinedReasonId !== 8
            ) {
              if (!seenIds.has(subService.id)) {
                seenIds.add(subService.id)
                services.push(subService)
              }
            }
          }
        } else {
          if (
            !service.deferred &&
            !service.isHighlighted &&
            service.category !== '1' &&
            service.category !== '2' &&
            service.category !== '3' &&
            service.category !== '4' &&
            service.declinedReasonId !== 8
          ) {
            if (!seenIds.has(service.id)) {
              seenIds.add(service.id)
              services.push(service)
            }
          }
        }
      }
    }
    services.sort((a, b) => {
      const aSortOrder = getters.categoryById(a.category).sortOrder
      const bSortOrder = getters.categoryById(b.category).sortOrder
      return aSortOrder - bSortOrder
    })
    return services
  },
  servicesApprovedAtDealership: (state, getters) => {
    return getters.categoryServices('4')
  },
  respondBy: (state) => {
    return state.deadlines.respondBy === null ? null : new Date(state.deadlines.respondBy)
  },
  readyBy: (state) => {
    return state.deadlines.readyBy === null ? null : new Date(state.deadlines.readyBy)
  },
  serviceById: (state) => (id) => {
    for (const service of state.services) {
      if (service.id === id) {
        return service
      }
      if (service.subServices) {
        for (const subService of service.subServices) {
          if (subService.id === id) {
            return subService
          }
        }
      }
    }
  },
  firstApprovedServices: (state, getters) => {
    let firstApprovedServices = []
    const seenIds = new Set() // Track seen IDs to avoid duplicates

    state.services.forEach((service) => {
      if (
        service.category !== '3' &&
        service.category !== '4'
      ) {
        if (service.subServices) {
          service.subServices.forEach((subService) => {
            // Skip child sublets - they should only appear under their parent via subletServices
            if (subService.parentServiceLineIdForSublet !== null && subService.parentServiceLineIdForSublet !== undefined) {
              return
            }
            if (subService.isSelected) {
              if (!seenIds.has(subService.id)) {
                seenIds.add(subService.id)
                firstApprovedServices.push(subService)
              }
            }
          })
        } else {
          // Skip child sublets - they should only appear under their parent via subletServices
          if (service.parentServiceLineIdForSublet !== null && service.parentServiceLineIdForSublet !== undefined) {
            return
          }
          if (service.isSelected) {
            if (service.category !== '1' && service.category !== '2') {
              if (!seenIds.has(service.id)) {
                seenIds.add(service.id)
                firstApprovedServices.push(service)
              }
            }
          }
        }
      }
    })

    return firstApprovedServices
  },
  total: (state, getters) => {
    let inspectionTotal = 0
    let serviceTotal = 0
    let additionalTotal = 0

    // Helper function to add sublet prices
    const addSubletPrices = (service) => {
      let subletTotal = 0
      if (service.subletServices && service.subletServices.length > 0) {
        service.subletServices.forEach((sublet) => {
          subletTotal += sublet.price || 0
        })
      }
      return subletTotal
    }

    // limit to displayed and leave out the pass category
    state.categories.forEach((category) => {
      if (category.showOnInspection && category.id !== '3') {
        state.services.forEach((service) => {
          if (service.category === category.id) {
            if (service.subServices) {
              service.subServices.forEach((subService) => {
                if (subService.isSelected) {
                  inspectionTotal += subService.price
                }
              })
            } else {
              if (category.id !== '1' && category.id !== '2') {
                if (service.isSelected) {
                  inspectionTotal += service.price
                }
              }
            }
          }
        })
      }

      if (category.id === '4') {
        state.services.forEach((service) => {
          if (service.category === '4') {
            if (service.subServices) {
              service.subServices.forEach((subService) => {
                serviceTotal += subService.price
              })
            } else {
              serviceTotal += service.price
            }
          }
        })
      }

      if (category.id === '5') {
        state.services.forEach((service) => {
          if (
            service.category === '6' ||
            service.category === '7'
          ) {
            if (service.subServices) {
              service.subServices.forEach((subService) => {
                if (subService.isSelected) {
                  inspectionTotal += subService.price
                }
              })
            }
          }
        })
      }
    })

    for (const category of getters.categoriesShown) {
      for (const service of getters.categoryServicesShownOnRoute(category.id)) {
        if (service.isSelected) {
          additionalTotal += service.price
          // Add child sublet prices
          additionalTotal += addSubletPrices(service)
        }
      }
    }

    return {
      service: serviceTotal,
      inspection: inspectionTotal,
      additional: additionalTotal
    }
  }
}

export default getters
